// src/App.js
import React from 'react';
import PieChart from '../pie/miterbiterPieChart';


function MonthlyReport() {
  return (
    <div className="App">
      <header className="App-header">
        <PieChart />
      </header>
    </div>
  );
}

export default MonthlyReport;
